import React from "react";
import { ArrowLeft } from "@phosphor-icons/react";
import { motion } from "framer-motion";
import CTASection from "./sections/CTASection";
import "./css/AboutUsPage.css";

const AboutUsPage = () => {
  const handleBack = () => {
    window.history.back();
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" }
    }
  };

  return (
    <div className="aboutus-page">
      <main className="aboutus-container">
        <motion.div
          initial="hidden"
          animate="visible"
          variants={containerVariants}
        >
          <motion.button
            className="back-button"
            onClick={handleBack}
            variants={itemVariants}
          >
            <ArrowLeft size={18} weight="bold" />
            Back
          </motion.button>

          <div className="aboutus-header">
            <motion.span className="aboutus-mission-badge" variants={itemVariants}>
              OUR MISSION
            </motion.span>
            <motion.h1 className="aboutus-title" variants={itemVariants}>
              Growing businesses, <br />
              respecting people.
            </motion.h1>
          </div>

          <div className="aboutus-grid">
            <motion.div className="aboutus-left" variants={itemVariants}>
              <div className="aboutus-secondary-text">
                <p>
                  At <strong>Ravooka Ads</strong>, our mission is simple: <strong>grow your business while respecting the experience of every user</strong>. We connect advertisers with the right audience, while helping publishers monetize their content without compromising quality.
                </p>
              </div>
            </motion.div>

            <motion.div className="aboutus-right" variants={itemVariants}>
              <div className="aboutus-secondary-text">
                <p>
                  We believe in <strong>ads that work for everyone</strong> — campaigns that deliver <strong>real attention, real results</strong>, and revenue that <strong>doesn't ruin the user experience</strong>. Whether you're a brand looking to <strong>reach the right people at the right time</strong>, or a publisher aiming to <strong>maximize revenue without clutter</strong>, our platform is built to <strong>balance growth, trust, and performance</strong>.
                </p>
                <p>
                  Our approach is smart, fair, and designed to <strong>earn its place</strong> on every page. With <strong>ads that hustle with you, pull their weight, and convert responsibly</strong>, Ravooka Ads ensures that your investment drives <strong>momentum, engagement, and impact</strong>.
                </p>
              </div>
            </motion.div>
          </div>

          <motion.div className="aboutus-closing" variants={itemVariants}>
            <p className="aboutus-closing-text">
              "<strong>Better ads, for everyone.</strong>"
            </p>
          </motion.div>
        </motion.div>
      </main>

      {/* CTA Section */}
      <CTASection />
    </div>
  );
};

export default AboutUsPage;
